import React from 'react';
import '../../scss/CloseIcon.scss';

export default ({ action }) => (
    <div className='close' onClick={action} role='button' tabIndex={0} onKeyPress={e => e.key === 'Enter' && action}>
        <div className='icon' />
    </div>
);
